// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__RLEHc","row":"ProcedureTreatmentSummary_row__5W7VA"};